import {createAction, props} from '@ngrx/store';
import {LoggedUserDataModel} from '../modules/rest/user/response/logged-user-data.model';

export const GetLoggedUserData = createAction(
    '[Core] Get logged user'
);

export const GetLoggedUserDataSuccess = createAction(
    '[Core] Get logged user success',
    props<{ loggedUserData: LoggedUserDataModel }>()
);

export const WizardOpened = createAction(
    '[Core] Wizard page opened'
);

export const ConsentOpened = createAction(
    '[Core] Consent page opened'
);

export const AnamnesisOpened = createAction(
    '[Core] Anamnesis questionnaire page opened'
);

export const PatientOverviewOpened = createAction(
    '[Core] Patient overview page opened'
);

export const UpdateUserPersonalSettings = createAction(
    '[Core] Update user personal settings',
    props<{ settings: string }>()
);

export const UpdateUserPersonalSettingsSuccess = createAction(
    '[Core] Update user personal settings success',
    props<{ settings: string }>()
);



